import { Component, OnInit } from '@angular/core';
import { FeatureHeroService } from '../home/feature-hero.service';

@Component({
  selector: 'app-promotional-hero',
  templateUrl: './promotional-hero.component.html',
  styleUrls: ['./promotional-hero.component.scss'],
})
export class PromotionalHeroComponent implements OnInit {
  private _readFeatureHeroVersion: string | undefined;
  // This is to be changed on every version update, explore if we have an app version exposed somewhere
  private _featureHeroVersion: string = '0.0.5';

  constructor(private _featureHeroService: FeatureHeroService) {}

  public get showHero(): boolean {
    return this._readFeatureHeroVersion !== this._featureHeroVersion;
  }

  ngOnInit(): void {
    this._readFeatureHeroVersion = this._featureHeroService.getFeatureHeroVersion();
  }

  public remindMeLater(): void {
    this._readFeatureHeroVersion = this._featureHeroVersion;
  }

  public gotIt(): void {
    this._readFeatureHeroVersion = this._featureHeroService.setFeatureHeroVersion(this._featureHeroVersion);
  }
}
